"use strict";
/* eslint-disable no-lonely-if,brace-style */

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getStatePovertyLevel(dirtyState, persons) {
  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "monthly";
  if (dirtyState == null) throw new Error("Missing State");
  if (persons == null) throw new Error("Missing Persons Count");
  var state = dirtyState.toUpperCase(); // NOTE: these values should match poverty guidelines w/o multiplier!
  // https://aspe.hhs.gov/poverty-guidelines

  var cutoff = null;

  if (state === "AK") {
    // WARNING: make sure these are poverty guidelines w/o multiplier!
    if (persons === 1) {
      cutoff = 16990;
    } else if (persons === 2) {
      cutoff = 22890;
    } else if (persons === 3) {
      cutoff = 28790;
    } else if (persons === 4) {
      cutoff = 34690;
    } else if (persons === 5) {
      cutoff = 40590;
    } else if (persons === 6) {
      cutoff = 46490;
    } else if (persons === 7) {
      cutoff = 52390;
    } else if (persons === 8) {
      cutoff = 58290;
    } else {
      cutoff = 58290 + 5900 * (persons - 8);
    }
  } else if (state === "HI") {
    // WARNING: make sure these are poverty guidelines w/o multiplier!
    if (persons === 1) {
      cutoff = 15630;
    } else if (persons === 2) {
      cutoff = 21060;
    } else if (persons === 3) {
      cutoff = 26490;
    } else if (persons === 4) {
      cutoff = 31920;
    } else if (persons === 5) {
      cutoff = 37350;
    } else if (persons === 6) {
      cutoff = 42780;
    } else if (persons === 7) {
      cutoff = 48210;
    } else if (persons === 8) {
      cutoff = 53640;
    } else {
      cutoff = 53640 + 5430 * (persons - 8);
    }
  } else {
    // WARNING: make sure these are poverty guidelines w/o multiplier!
    if (persons === 1) {
      cutoff = 13590;
    } else if (persons === 2) {
      cutoff = 18310;
    } else if (persons === 3) {
      cutoff = 23030;
    } else if (persons === 4) {
      cutoff = 27750;
    } else if (persons === 5) {
      cutoff = 32470;
    } else if (persons === 6) {
      cutoff = 37190;
    } else if (persons === 7) {
      cutoff = 41910;
    } else if (persons === 8) {
      cutoff = 46630;
    } else {
      cutoff = 46630 + 4720 * (persons - 8);
    }
  }

  return period === "monthly" ? Number(Number(cutoff * multiplier / 12).toFixed(2)) : Number(cutoff * multiplier).toFixed(2);
}

exports.default = getStatePovertyLevel;